import * as React from 'react';
import { css, html } from 'react-strict-dom';
import { spacing } from 'src/constants/spacing.css';

type Value = true | number;

type Props = {
  gap?: Value;
  padH?: Value;
  padV?: Value;
  children: React.ReactNode;
  style?: css.StyleXStyles;
};

export default function Stack({ children, gap, padH, padV, style }: Props) {
  return (
    <html.div
      style={[
        styles.baseStyle,
        ...(gap ? [styles.gap(gap)] : []),
        ...(padV ? [styles.paddingVertical(padV)] : []),
        ...(padH ? [styles.paddingHorizontal(padH)] : []),
        style,
      ]}
    >
      {children}
    </html.div>
  );
}

function toNumber(amount: Value): number {
  if (amount === true) return 1;

  return amount;
}

const styles = css.create({
  baseStyle: {
    display: 'flex',
    flexDirection: 'column',
  },
  paddingVertical: (size: Value) => ({
    paddingBlock: `calc(${spacing.unit} * ${toNumber(size)})`,
  }),
  paddingHorizontal: (size: Value) => ({
    paddingInline: `calc(${spacing.unit} * ${toNumber(size)})`,
  }),
  gap: (size: Value) => ({
    gap: `calc(${spacing.unit} * ${toNumber(size)})`,
  }),
});
